/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'active-sub': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M9.06 9.948A3.973 3.973 0 109.06 2a3.973 3.973 0 00.001 7.947z" _stroke="#2E48DA" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M16 16a6.055 6.055 0 00-6.055-6.057h-1.89A6.055 6.055 0 002 16" _stroke="#2E48DA" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/active-sub.js